import Factory from '../utils/factory'
import Fee from '../Residential/fee'

export default Factory({
  properties: [
    {
      key: 'propertyType',
      label: null,
      value: null,
    },
    {
      key: 'ownershipType',
      label: null,
      value: null,
    },
    {
      key: 'primaryRoomArea',
      label: null,
      value: null,
    },
    {
      key: 'useableArea',
      label: null,
      value: null,
    },
    {
      key: 'numberOfFloors',
      label: null,
      value: null,
    },
    {
      key: 'numberOfBedrooms',
      label: null,
      value: null,
    },
    {
      key: 'numberOfBathrooms',
      label: null,
      value: null,
    },
  ],
  description: null,
  media: {
    cover: null,
    gallery: null,
    floorplan: null,
    attachments: null,
  },
  sale: {
    value: null,
    fixed: true,
    jointDebt: null,
    jointDebtInterestRate: null,
    deposit: null,
    fee: Fee(),
  }
})
